import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-browser-info',
	templateUrl: './modal-browser-info.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ModalBrowserInfoComponent implements OnInit {
	private dialogRef = inject(MatDialogRef<ModalBrowserInfoComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.close = this.close;
	}
	
	close() {
		this.dialogRef.close();
	}
	
}